import { AsyncActions  } from '../../standard-actions';
import { CHANNEL_CARE_LOAD_COMPANY_MULTI_CIDN , CHANNEL_CARE_UPDATE_COMPANY_ID} from './action-types';
import { ICompanyResponse } from '../state/company-multi-cidn';

export interface ILoadCompanyAction extends AsyncActions.IAsyncFetchableAction<CHANNEL_CARE_LOAD_COMPANY_MULTI_CIDN> {
}

export interface ILoadCompanySuccessAction extends AsyncActions.IAsyncAction<CHANNEL_CARE_LOAD_COMPANY_MULTI_CIDN> {
    data: ICompanyResponse;
}

export type LoadCompanyErrorAction = AsyncActions.IAsyncErrorAction<CHANNEL_CARE_LOAD_COMPANY_MULTI_CIDN>;

export interface IUpdateCompanyIdAction {
    type: CHANNEL_CARE_UPDATE_COMPANY_ID;
    companyId: string;
};

export const loadCompanyStart = (): ILoadCompanyAction => ({
    status: AsyncActions.AsyncActionState.Initiated,
    type: CHANNEL_CARE_LOAD_COMPANY_MULTI_CIDN,
    isFetchable: true
});

export const loadCompanySuccess = (data: ICompanyResponse): ILoadCompanySuccessAction => ({
    status: AsyncActions.AsyncActionState.Success,
    type: CHANNEL_CARE_LOAD_COMPANY_MULTI_CIDN,
    data
});

export const loadCompanyError = (error: string): LoadCompanyErrorAction => ({
    status: AsyncActions.AsyncActionState.Failure,
    type: CHANNEL_CARE_LOAD_COMPANY_MULTI_CIDN,
    error
});
export const updateCompanyNotStartAction = (): ILoadCompanyAction => ({
    status: AsyncActions.AsyncActionState.NotStarted,
    type: CHANNEL_CARE_LOAD_COMPANY_MULTI_CIDN,
    isFetchable: true
});
export const updateCompanyIdAction = (companyId: string): IUpdateCompanyIdAction => ({
    type: CHANNEL_CARE_UPDATE_COMPANY_ID,
    companyId
});
